import type { History } from "history";
import moment from "moment";
import { AppRoutes } from "../../routes/routeConstants/appRoutes";

/** Query param used to scroll to and highlight a case row after navigation (e.g. from notifications). */
export const HIGHLIGHT_CASE_QUERY_KEY = "highlightCaseId";

export function parseHighlightCaseIdFromSearch(search: string): number | null {
  const q = new URLSearchParams(search);
  const v = q.get(HIGHLIGHT_CASE_QUERY_KEY);
  if (!v) return null;
  const n = parseInt(v, 10);
  return Number.isNaN(n) ? null : n;
}

export function searchWithoutKey(search: string, key: string): string {
  const q = new URLSearchParams(search);
  q.delete(key);
  const s = q.toString();
  return s ? `?${s}` : "";
}

/**
 * Navigate to the case listing with highlight + optional chat drawer.
 * Merges with current HOME query when already on `/`; otherwise applies a wide
 * default date range so the case is likely included (today-only default would hide it).
 */
export function navigateToCaseListingWithHighlight(
  history: History,
  caseId: number,
  options?: { openChat?: boolean }
): void {
  const path = history.location.pathname;
  const q = new URLSearchParams(
    path === AppRoutes.HOME ? history.location.search : ""
  );
  if (!q.get("fromDate")) {
    q.set("fromDate", moment().subtract(2, "years").format("YYYY-MM-DD"));
    q.set("toDate", moment().format("YYYY-MM-DD"));
  }
  if (!q.get("toDate")) {
    q.set("toDate", moment().format("YYYY-MM-DD"));
  }
  q.set(HIGHLIGHT_CASE_QUERY_KEY, String(caseId));
  if (options?.openChat) {
    q.set("openChatCaseId", String(caseId));
  } else {
    q.delete("openChatCaseId");
  }
  history.push({ pathname: AppRoutes.HOME, search: `?${q.toString()}` });
}
